<template lang="pug">
  y-dialog(v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card(flat)
      v-card-title.pa-4
        div.h6.primary500--text {{ $t('edit_weight') }}
        v-spacer
        v-btn(color="transparent" icon small @click="showModal = !showModal")
          eva-icon.mt-1(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
      v-card-text.pa-4
        div.label.basic600--text.text-uppercase {{ $t('total_package_weight') }}
        v-row(no-gutters align="center")
          v-col(cols="7")
            v-text-field.mt-2(v-model.number="weight" background-color="basic200" outlined dense height="40" hide-details="auto" type="number" suffix="kg" step="0.1")
          v-col.pl-2
            v-btn(color="transparent" icon small @click="weight = yezzaShipping.products_weight")
              eva-icon.mb-n2(name="refresh-outline" :fill="weight === yezzaShipping.products_weight ? $vuetify.theme.themes[$theme].basic400 : $vuetify.theme.themes[$theme].primary500" width="24" height="24")
      v-card-actions.px-4.pb-4
        v-btn(color="success500" depressed height="40" @click="clickSave" :loading="isLoading" dark block)
          .button-AA-medium.basic100--text.mx-2 {{ $t('save_changes') }}

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EditWeight',
  props: ['open', 'parentYezzaShipping', 'parentRates'],
  data: () => ({
    isLoading: false,
    weight: 0
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    yezzaShipping: {
      get () {
        return this.parentYezzaShipping
      },
      set (newValue) {
        this.$emit('update:parentYezzaShipping', newValue)
      }
    },
    rates: {
      get () {
        return this.parentRates
      },
      set (newValue) {
        this.$emit('update:parentRates', newValue)
      }
    }
  },
  mounted () {
    this.weight = this.yezzaShipping.weight
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave () {
      this.isLoading = true
      this.$axios.patch(`/shipping/yezzashipping/${this.yezzaShipping.id}`, { weight: this.weight })
        .then(resp => {
          this.yezzaShipping = resp.data
          this.$emit('updateWeight')
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "total_package_weight": "Total package weight"
  },
  "id": {
    "total_package_weight": "Total berat paket"
  }
}
</i18n>